import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-predictive-health',
  templateUrl: './predictive-health.component.html',
  styleUrls: ['./predictive-health.component.scss']
})
export class PredictiveHealthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
